var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "#515864"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontSize: 14,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 14
  }, "2")))));
}
export default SvgTwoBig;